import { useState, type FormEvent } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';

const navItems = [
  { to: '/', label: '首页' },
  { to: '/category', label: '分类' },
  { to: '/search', label: '搜索' },
  { to: '/about', label: '关于' },
];

export default function Navbar() {
  const [keyword, setKeyword] = useState('');
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();

  const handleSearch = (e: FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    navigate(q ? `/search?q=${encodeURIComponent(q)}` : '/search');
    setMenuOpen(false);
  };

  const linkClass = ({ isActive }: { isActive: boolean }) =>
    `whitespace-nowrap rounded-md px-3 py-2 text-sm transition-colors ${
      isActive
        ? 'bg-primary-50 text-primary-600 font-medium'
        : 'text-foreground-700 hover:text-primary-600'
    }`;

  return (
    <header className="sticky top-0 z-50 border-b border-background-200 bg-background-50/90 backdrop-blur">
      <div className="flex h-16 items-center gap-4 px-4 md:px-6">
        <Link to="/" className="flex items-center gap-2 shrink-0">
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 text-background-50">
            <i className="ri-movie-2-fill text-lg"></i>
          </span>
          <span className="font-heading text-base font-semibold text-foreground-950 md:text-lg">
            善良的小姨子在线
          </span>
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {navItems.map((item) => (
            <NavLink key={item.to} to={item.to} className={linkClass} end={item.to === '/'}>
              {item.label}
            </NavLink>
          ))}
        </nav>

        <form onSubmit={handleSearch} className="ml-auto hidden md:flex items-center">
          <div className="flex items-center overflow-hidden rounded-md border border-background-300 bg-background-100">
            <span className="flex h-9 w-9 items-center justify-center text-foreground-500">
              <i className="ri-search-line text-base"></i>
            </span>
            <input
              type="text"
              value={keyword}
              onChange={(e) => setKeyword(e.target.value)}
              placeholder="搜索剧名或主演"
              className="h-9 w-40 bg-transparent pr-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400 focus:w-52 transition-all"
            />
          </div>
          <button
            type="submit"
            className="ml-2 whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 cursor-pointer"
          >
            搜索
          </button>
        </form>

        <button
          type="button"
          onClick={() => setMenuOpen((v) => !v)}
          aria-label="展开菜单"
          className="ml-auto flex h-10 w-10 items-center justify-center rounded-md border border-background-300 text-foreground-800 md:hidden cursor-pointer"
        >
          <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
        </button>
      </div>

      {menuOpen && (
        <div className="border-t border-background-200 bg-background-50 px-4 py-4 md:hidden animate-soft-in">
          <form onSubmit={handleSearch} className="mb-4 flex items-center gap-2">
            <div className="flex flex-1 items-center overflow-hidden rounded-md border border-background-300 bg-background-100">
              <span className="flex h-10 w-10 items-center justify-center text-foreground-500">
                <i className="ri-search-line"></i>
              </span>
              <input
                type="text"
                value={keyword}
                onChange={(e) => setKeyword(e.target.value)}
                placeholder="搜索剧名或主演"
                className="h-10 w-full bg-transparent pr-3 text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
              />
            </div>
            <button
              type="submit"
              className="whitespace-nowrap rounded-md bg-primary-500 px-4 py-2.5 text-sm font-medium text-background-50 cursor-pointer"
            >
              搜索
            </button>
          </form>
          <nav className="grid grid-cols-2 gap-2">
            {navItems.map((item) => (
              <NavLink
                key={item.to}
                to={item.to}
                onClick={() => setMenuOpen(false)}
                className={({ isActive }) =>
                  `rounded-md px-4 py-3 text-sm ${
                    isActive
                      ? 'bg-primary-50 text-primary-600 font-medium'
                      : 'bg-background-100 text-foreground-800'
                  }`
                }
                end={item.to === '/'}
              >
                {item.label}
              </NavLink>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}